import { Injectable } from '@angular/core';
import { LZStringService } from 'ng-lz-string';

import { PARTBNB_GLOBAL } from '@shared/constants/partBnbGlobal';
import { UsersService } from '@shared/api';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  sessionTime: number = PARTBNB_GLOBAL.SESSION_TIME;
  isRunningSession: boolean = false;

  constructor(
    private _lzString: LZStringService,
    private _usersService: UsersService
  ) {}

  resetSessionTime() {
    const partJWT = localStorage.getItem('part_jwt');
    if (partJWT) {
      this._usersService.getAccess().subscribe(token => {
        if (token) {
          this.setToken(token);
        }
      });
    }
    // if (!this.isRunningSession) {
    //   this.isRunningSession = true;
    //   const runningSession = setTimeout(() => {
    //     this.isRunningSession = false;
    //     this.updateToken();
    //     clearTimeout(runningSession);
    //   }, this.sessionTime);
    // }
  }

  updateToken() {
    const partJWT = localStorage.getItem('part_jwt');
    if (partJWT) {
      this._usersService.getAccess().subscribe(token => {
        if (token) {
          this.setToken(token);
        }
      });
    } else {
      localStorage.removeItem('currentUser');
      location.reload(true);
    }
  }

  setToken(token: string) {
    const compressToken = this._lzString.compress(token);
    localStorage.setItem('part_jwt', compressToken);
  }

  getToken() {
    const partJWT = localStorage.getItem('part_jwt');
    return partJWT ? this._lzString.decompress(partJWT) : null;
  }

  removeToken() {
    localStorage.removeItem('part_jwt');
  }
}
